module.exports = __webpack_public_path__ + "img/coupon.e12345c.png";